<script lang="ts" setup>
import { Modal } from "@/components";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { locale } = useI18n();

const store = useStore();

const emit = defineEmits(["close"]);

const text = computed(() =>
  store.getters.user.mergedConfig?.documentConfirmation &&
  store.getters.user.mergedConfig?.documentConfirmation[locale.value]
    ? store.getters.user.mergedConfig?.documentConfirmation[locale.value]
    : store.getters.user.mergedConfig?.documentConfirmation?.en,
);
</script>

<template>
  <Modal
    :active="true"
    @close="emit('close')"
    class="small hide_close"
    :closeDisabled="true"
  >
    <template #header>
      {{ $t("upload.documentConfirmation.title") }}
    </template>
    <template #body>
      <div class="text" v-html="text"></div>
    </template>

    <template #footer>
      <div class="buttons">
        <button class="button primary" @click="emit('close')">
          {{ $t("upload.documentConfirmation.ok") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<style scoped lang="scss">
.text {
  font-size: 0.9em;
  text-align: left;
}
</style>
